/**
 * Created by Ivan on 24.05.2025
 */

const CurtainTutorial = function () {
    return new TutorialScenario(CurtainTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(CurtainTutorial.CONFIG.tutorial[0]),
            TileGameTutorialHelper.createPlayCardStep(CurtainTutorial.CONFIG.tutorial[1])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(CurtainTutorial.NAME);
            Game.currentGame.hand.setCards(CurtainTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(CurtainTutorial.NAME)
    });
};

CurtainTutorial.NAME = "curtain";
CurtainTutorial.CONFIG = {
    handValues: ["4"],
    tutorial: [{
        force: "CurtainTutorialMessage1",
        filter: [CurtainCard]
    }, {
        force: "CurtainTutorialMessage2",
        filter: [CurtainCard]
    }]
};
